import styled from '@emotion/styled';

export const AppBodyWrapperDiv = styled.main`
  width: 100%;
  margin: 0 auto;
  height: inherit;
`;

export const ContentWrapperDiv = styled.div<{overflow: string}>`
  background-color: ${({theme}) => theme.palette.common.white};
  border-radius:5px;
  margin:1rem;
  padding: 0.25rem 0.5em;
  height: inherit;
  overflow: ${props => props.overflow};
`;
